import { withParams } from 'vuelidate/lib';

const softDescriptor = withParams({ type: 'softdescriptor' }, value => {
  var regex = new RegExp('^[0-9a-zA-Z]*$');
  return regex.test(value);
});

export { softDescriptor };
